import { useContext, useEffect } from 'react';
import clsx from 'clsx';

import WorkOrdersContext, {
  WorkOrdersInputActionTypes,
} from '@atom/components/workOrders/WorkOrdersContext';
import { Icon, Progress } from '@atom/mui';
import {
  Client,
  isCurrentClient,
} from '@atom/utilities/featureToggleUtilities';

import WorkOrdersFiltersFormSection from './WorkOrdersFiltersFormSection';
import WorkOrdersFiltersHeader from './WorkOrdersFiltersHeader';
import WorkOrdersFiltersInventorySection from './WorkOrdersFiltersInventorySection';
import WorkOrdersFiltersLocationSection from './WorkOrdersFiltersLocationSection';
import WorkOrdersFiltersTaskSection from './WorkOrdersFiltersTaskSection';
import WorkOrdersFiltersTeamSection from './WorkOrdersFiltersTeamSection';
import WorkOrdersFiltersWorkSection from './WorkOrdersFiltersWorkSection';

import classes from './workOrdersFilters.module.css';

const WorkOrdersFilters = () => {
  const { input, setInput, dispatch, loadingFilters } =
    useContext(WorkOrdersContext);

  const showLocationFilters = isCurrentClient([Client.ALDOT, Client.UDOT]);

  useEffect(() => {
    dispatch({
      type: WorkOrdersInputActionTypes.SET_WORK_ORDERS_INPUT,
      data: input,
    });
  }, [input]);

  const expandIcon = input?.expanded ? 'arrow_left' : 'arrow_right';
  const toggleExpanded = () => {
    setInput({
      ...input,
      expanded: !input?.expanded,
    });
  };

  return (
    <div
      className={clsx(
        classes.filtersContainer,
        !input?.expanded && classes.collapsed,
      )}
    >
      <div
        className={clsx(
          classes.expandButton,
          !input?.expanded && classes.collapsed,
        )}
        onClick={toggleExpanded}
      >
        <Icon>{expandIcon}</Icon>
      </div>
      <WorkOrdersFiltersHeader />
      {loadingFilters ? (
        <div className={classes.filterLoadingContainer}>
          <Progress />
        </div>
      ) : (
        <div className={classes.filtersContent}>
          <WorkOrdersFiltersWorkSection />
          <WorkOrdersFiltersTaskSection />
          {showLocationFilters && <WorkOrdersFiltersLocationSection />}
          <WorkOrdersFiltersTeamSection />
          <WorkOrdersFiltersInventorySection />
          <WorkOrdersFiltersFormSection />
        </div>
      )}
    </div>
  );
};

export default WorkOrdersFilters;
